const indexItems = [
  {
    id: 1,
    title: '热播电视剧专区',
    desc: '最新上线的热门电视剧高清全集，涵盖国产剧、日韩剧、欧美剧等',
    icon: 'ri-tv-2-line',
    count: '2800+',
    accent: true,
  },
  {
    id: 2,
    title: '电影大片频道',
    desc: '院线新片、经典老片、独立电影，各类电影资源一应俱全',
    icon: 'ri-film-line',
    count: '5600+',
    accent: false,
  },
  {
    id: 3,
    title: '综艺娱乐合集',
    desc: '热门综艺最新期数，搞笑、音乐、真人秀全覆盖',
    icon: 'ri-emotion-laugh-line',
    count: '1500+',
    accent: false,
  },
  {
    id: 4,
    title: '动漫番剧天地',
    desc: '国产动漫与日本番剧精选，热血、治愈、奇幻等多样风格',
    icon: 'ri-ghost-smile-line',
    count: '3200+',
    accent: true,
  },
  {
    id: 5,
    title: '纪录片频道',
    desc: '自然、人文、历史、科技等优质纪录片，拓宽你的视野',
    icon: 'ri-global-line',
    count: '1800+',
    accent: false,
  },
  {
    id: 6,
    title: '悬疑推理剧场',
    desc: '烧脑悬疑、推理破案类影视作品精选，挑战你的推理能力',
    icon: 'ri-search-eye-line',
    count: '960+',
    accent: false,
  },
  {
    id: 7,
    title: '科幻奇幻世界',
    desc: '科幻大片与奇幻巨制，带你进入想象力的无限边界',
    icon: 'ri-rocket-2-line',
    count: '1200+',
    accent: false,
  },
  {
    id: 8,
    title: '喜剧搞笑乐园',
    desc: '轻松搞笑的喜剧电影和情景剧，为你带来欢乐时光',
    icon: 'ri-emotion-happy-line',
    count: '2100+',
    accent: true,
  },
];

export default function Index() {
  return (
    <section id="index" className="py-16 md:py-24 bg-background-100">
      <div className="w-full max-w-[1200px] mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-secondary-100 text-secondary-700 text-xs font-medium mb-4">
            <i className="ri-grid-line"></i>
            <span>内容导航</span>
          </div>
          <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-950">
            专题合集
          </h2>
          <p className="text-sm md:text-base text-foreground-600 mt-3 max-w-lg mx-auto">
            按类型快速浏览，找到你感兴趣的内容专区
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {indexItems.map((item) => (
            <a
              key={item.id}
              href="#media"
              onClick={(e) => {
                e.preventDefault();
                const el = document.querySelector('#media');
                if (el) el.scrollIntoView({ behavior: 'smooth' });
              }}
              className={`group rounded-xl p-5 border transition-all duration-300 cursor-pointer ${
                item.accent
                  ? 'bg-accent-50 border-accent-200 hover:border-accent-400'
                  : 'bg-background-50 border-background-200/70 hover:border-primary-300'
              }`}
            >
              <div className={`w-10 h-10 rounded-lg flex items-center justify-center mb-3 ${
                item.accent ? 'bg-accent-100' : 'bg-primary-100'
              }`}>
                <i className={`${item.icon} text-lg ${
                  item.accent ? 'text-accent-600' : 'text-primary-500'
                }`}></i>
              </div>
              <div className="flex items-center justify-between mb-1.5">
                <h3 className="text-sm font-semibold text-foreground-900">
                  {item.title}
                </h3>
                <span className={`text-xs font-medium ${
                  item.accent ? 'text-accent-600' : 'text-primary-500'
                }`}>
                  {item.count}
                </span>
              </div>
              <p className="text-xs text-foreground-500 leading-relaxed">
                {item.desc}
              </p>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}